import { Component } from 'react';
import classNames from 'classnames';
import Icon from 'noc/components/icon';
import ColumnFilterHeader from 'noc/components/column-filter-header';

class FilterAndViews extends Component {
    constructor(props) {
        super(props);
        this.updateSearch = this.updateSearch.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.showAllId = props.tabsData.find(x => x.Sequence == 1).Id;
        this.showAll = window.showAll();
        this.showButton = true;
        this.filterArray = [];
        this.TktParameterDisplayName = '';
        this.showCopyClipBoardButton = window.showCopyClipBoardButton();
    }

    render() {
        const {
            fetchTicketCountData,ticketsData, ticketCheckboxArray, columnFilters, toggle,
            setElapsedTime, elapsed, refresh, tabsData, ticketCategoryData,
            requestForId, getTabData,OwnerTeamData
        } = this.props;

        let tabData;
        tabsData.map(tab => {
            if (tab.Id === requestForId) {
                tabData = tab;
            }
        });

        this.TktParameterDisplayName = tabData.DisplayName;
        this.showButton = (ticketCheckboxArray.length > 0 && this.checkValidTickets()) ? false : true;

        if (this.showAll) {
            const showAll = tabData.IsShowAll ? true : false;
            this.showAllId = tabsData.find(x => x.IsShowAll).Id;
        }

        const viewFilterFlag = columnFilters.find(x => x.eventName === 'ViewFilter');
        const tabFilterFlag = columnFilters.find(x => x.eventName === 'TabFilter');
        const filterMenuClasses = classNames({
            'cn-linkset__opt': true,
            'noc-linkset__opt': true
        });

        const filterLinkClasses = classNames({
            'cn-toolbar__link': true,
            'cn-linkset__opt--active': (tabFilterFlag.isStatus)
        });

        let enableFilterMenu = true;

        if (ticketCategoryData) {
            const tileCategory = ticketCategoryData.find(c => c.Id === parseInt(requestForId));
            enableFilterMenu = tileCategory ? tileCategory.TotalCount <= 0 : false;
        } else {
            enableFilterMenu = false;
        }

        return (
            <div className="filters-views">
                <div className="main-header clearfix">
                    <strong className="header">TICKETS</strong>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    {this.showAll ?
                        <span>
                            <input
                                className="cn-field__checkradio"
                                name="isChecked"
                                checked={showAll}
                                onChange={this.handleInputChange}
                                type="checkbox"
                            />
                            &nbsp;
                            <strong className="sub-header">{tabsData.find(x => x.IsShowAll).DisplayName}</strong>
                        </span>
                        : null}
                </div>

                <div className="sub-header clearfix">

				
                    {
                        this.showCopyClipBoardButton && OwnerTeamData.length > 1 ?
                           <button
                               className="btn btn-primary" disabled={this.showButton}
                               onClick={this.handleClick.bind(this)}
                           >
                               SEND MESSAGE
                           </button>
                           :
                           null
                    } 

                    <div className="pull-right">
                        <div className={filterMenuClasses}>
                            {
                                enableFilterMenu ?
                                    <strong className="cn-toolbar__link cn-toolbar__link--disabled">
                                        SHOW FILTERS
                                        <Icon type="cn-icon--tool" icon="icon-triangle-down" />
                                    </strong>
                                    :
                                    <a
                                        href="javascript:;" className={filterLinkClasses}
                                        onClick={() => toggle(columnFilters, 'TabFilter')}
                                    >
                                        <strong>{tabFilterFlag.isStatus ? 'HIDE' : 'SHOW'} FILTERS</strong>
                                        <Icon
                                            type="cn-icon--tool"
                                            icon={tabFilterFlag.isStatus ? 'icon-triangle-up' : 'icon-triangle-down'}
                                        />
                                    </a>
                            }
                            | <strong>
                                {tabData.QueueViewGrid.TotalRecords}
                            </strong> Records
                            { viewFilterFlag.isStatus ? this.renderColumnFilterMenu() : null }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    convertMinToDays(duration, TicketParameter) {
        if (TicketParameter != 5) {
            var minutes = parseInt((duration) % 60),
                hours = parseInt((duration / (60)) % 24),
                days = parseInt((duration / (24 * 60)) % (24 * 60));

            hours = (hours < 10) ? "0" + hours : hours;
            minutes = (minutes < 10) ? "0" + minutes : minutes;
            days = (days < 10) ? "0" + days : days;

            return days + 'd:' + hours + 'h:' + minutes + 'm';
        }

        return duration;
    }

    checkValidTickets() {
        const { ticketsData, ticketCheckboxArray } = this.props;
        const printArray = ticketsData.filter(function (itm) {
            return ticketCheckboxArray.indexOf(itm.TicketId) > -1;
        });
        this.filterArray = printArray.map(p => (
            {
                TicketId: p.TicketId,
                OwnerTeamName: p.OwnerTeamName,
                TicketParameter: p.TicketParameter,
                ThresholdStatus: p.ThresholdStatus,
                PriorityName: p.PriorityName,
                BreachCount_Up:
                p.BreachCount_Up,
                ParameterId: p.ParameterID
            }
        ));
        const resultBool = this.checkValidation(this.filterArray);
        return resultBool;
    }

    checkValidation(printArray) {
        let finalStatus = true;
        if (printArray.length > 1) {
            let isSameTeam = true;
            for (var i = 1; i < printArray.length; i++) {
                if (printArray[i].OwnerTeamName !== printArray[0].OwnerTeamName) {
                    isSameTeam = false;
                }
            }
            if (isSameTeam) {
                for (var i = 1; i < printArray.length; i++) {
                    if (printArray[i].ThresholdStatus !== printArray[0].ThresholdStatus) {
                        finalStatus = false;
                    }
                }
            } else {
                finalStatus = false;
            }
        }
        return finalStatus;
    }


    handleClick(event) {
        this.filterArray = this.filterArray.map(p => ({ 'Ticket Id': p.TicketId, 'Owner Team': p.OwnerTeamName, 'Ticket Parameter': this.TktParameterDisplayName, 'Threshold Status': p.ThresholdStatus, 'Ticket Priority': p.PriorityName, 'Breach Count-up': this.convertMinToDays(p.BreachCount_Up,p.ParameterId) }));
        const formattedString = this.getFormattedString(this.filterArray);
        this.CopyClipboard(formattedString);
        this.filterArray.length = 0;
        event.preventDefault();
    }

    getFormattedString(printArray) {
        let stringFormat = '';
        for (var i in printArray) {
            if (i > 0)
                stringFormat = stringFormat + ('-------------------------') + '\n';
            for (var j in printArray[i]) {
                stringFormat = stringFormat + [j] + ':' + printArray[i][j] + '\n';
            }
        }
        return stringFormat;
    }

    CopyClipboard(element) {
        const { fetchTicketCountData, requestForId } = this.props;
        const id = '_hiddenClipboard';
        const textarea = document.createElement('textarea');
        textarea.id = id;
        document.querySelector('body').appendChild(textarea);
        textarea.value = element;
        const scrollTop = (window.pageYOffset !== undefined)
                            ? window.pageYOffset
                            : (document.documentElement
                                || document.body.parentNode
                                || document.body).scrollTop;
        textarea.select();
        var status = document.execCommand('copy');
        document.body.removeChild(textarea);
        fetchTicketCountData(requestForId);
        (document.documentElement || document.body).scrollTop = scrollTop;
    }

    handleInputChange(e) {
        const { getTabData } = this.props;
        const { tabsData } = this.props;

        if (e.target.checked == true) {
            getTabData(this.showAllId);
        } else {
            const Id = tabsData.find(x => x.Sequence == 1).Id;
            getTabData(Id);
        }
    }

    updateSearch(e) {
        const { tabsData, requestForId } = this.props;
        const inputValue = this.refs.search.value;
        if (e.charCode === 13 || e.charCode === undefined) {
            const { dataSearch } = this.props;
            dataSearch(inputValue, requestForId, tabsData);
            this.refs.search.blur();
        }
    }

    renderColumnFilterMenu() {
        const { tabsData, isFilterChecked, onCheckedOfColumnFilter,
            requestForId, columnFilters, filteredDataColumns } = this.props;
        return (<ColumnFilterHeader
            requestForId={requestForId}
            tabsData={tabsData}
            isFilterChecked={isFilterChecked}
            onCheckedOfColumnFilter={onCheckedOfColumnFilter}
            isFilter={false}
            filterName="ViewFilter"
            columnFilters={columnFilters}
            filteredDataColumns={filteredDataColumns}
        />);
    }
}

export default FilterAndViews;



// WEBPACK FOOTER //
// ./app/tickets/components/filters-and-views.jsx